import { forwardRef, ReactNode } from 'react';
import { ProductCard, ProductCardProps } from '@croquiscom-pvt/zds';
import { css } from '@emotion/react';
import clsx from 'clsx';

export interface ProductCardRootProps extends Pick<ProductCardProps, 'size' | 'soldOut'> {
  children: ReactNode;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const productCardCss = css`
  position: relative;
  padding-bottom: 8px;
`;

export const ProductCardRoot = forwardRef<HTMLDivElement, ProductCardRootProps>((props, ref) => {
  const { className, size, soldOut, onClick, children } = props;

  return (
    <ProductCard
      className={clsx(['product-card-root', className])}
      css={productCardCss}
      ref={ref}
      size={size}
      soldOut={soldOut}
      onClick={onClick}
    >
      {children}
    </ProductCard>
  );
});
